export default "__VITE_ASSET__GHQD99YV__"